class form {
    constructor(config) {
        this.config = Object.assign({
            scope: 'form'
        }, config);

        this.$scope = $(this.config.scope);

        if (this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        $('.form-group-file').each((it, el) => {
            let $input = $(el);
            $input.addClass('form-group-text');
            let placeholder = $input.find('input.field-type-file').attr('placeholder');
            if (typeof placeholder === 'undefined') {
                placeholder = 'Bestand selecteren';
            }
            $input.append(`<input placeholder="${placeholder}" class="field-type-text form-control" type="text">`);
        });
        $('.form-group-file').on('input',(e) =>{
            let $input = $(e.currentTarget);
            let placeholder = $input.find('input.field-type-file').val().split('\\').pop();
            $input.find('.field-type-text').attr('placeholder', placeholder);
        })
    }



}

export default new form;
